import { render, staticRenderFns } from "./Wallets.htm?vue&type=template&id=a14219c6&scoped=true&"
import script from "./Wallets.js?vue&type=script&lang=js&"
export * from "./Wallets.js?vue&type=script&lang=js&"
import style0 from "./Wallets.scss?vue&type=style&index=0&id=a14219c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14219c6",
  null
  
)

export default component.exports